import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../AppIcon';
import Button from './Button';

const ConfirmationModal = ({ isOpen, onClose, onConfirm, title, message, confirmText, cancelText, variant = 'default' }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-card rounded-lg shadow-elevation-lg max-w-md w-full">
        <div className="p-6">
          <div className="flex items-start gap-4">
            <div className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 ${
              variant === 'destructive' ? 'bg-destructive/10' : 'bg-accent/10'
            }`}>
              <Icon 
                name={variant === 'destructive' ? 'AlertTriangle' : 'AlertCircle'} 
                size={20} 
                className={variant === 'destructive' ? 'text-destructive' : 'text-accent'}
              />
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-semibold text-foreground mb-2">
                {title || t('confirmModal.title')}
              </h3>
              <p className="text-sm text-muted-foreground">
                {message || t('confirmModal.message')}
              </p>
            </div>
          </div>
        </div>
        <div className="flex gap-3 p-6 pt-0">
          <Button
            variant="outline"
            onClick={onClose}
            className="flex-1"
          >
            {cancelText || t('confirmModal.cancel')}
          </Button>
          <Button
            variant={variant}
            onClick={onConfirm}
            className="flex-1"
          >
            {confirmText || t('confirmModal.confirm')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;